import { Fragment } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';

interface SectorsHeaderProps {
  title: string;
  description: string[];
}

export const SectorsHeader = ({ title, description }: SectorsHeaderProps) => {
  return (
    <div className='flex flex-col'>
      <div className='flex items-center gap-3'>
        <h1 className='text-4xl font-black text-gray-800 tracking-tighter'>
          {title}
        </h1>
        <Tooltip
          title={
            <div className='p-1'>
              {description.map((line, index) => (
                <Fragment key={index}>
                  <p className='text-xs py-0.5'>{line}</p>
                </Fragment>
              ))}
            </div>
          }
          arrow
          placement='right'
        >
          <InfoOutlinedIcon
            className='text-gray-300 hover:text-orange-500 cursor-help transition-colors'
            sx={{ fontSize: 24 }}
          />
        </Tooltip>
      </div>
    </div>
  );
};
